import {GadgetGroupElement} from "../element/Element";
/**
 * Created by Victor Rojo on 29/8/18.
 */
export class SimpleGadget{
  constructor(
    public gadgetId: string,
    public iPlaceId: string,
    public gadgetTypeId: number,
    public subtypeId: number,
    public decimalPrecision: string,
    public literal: string,
    public clickConfirmation: boolean,
    public tagTitle: string,
    public iconActive: string,
    public iconActiveData: number[],
    public iconInactive: number,
    public iconInactiveData: number[],
    public sectionId: string,
    public sectionName: string,
    public gadgetOrder: number,
    public rules: string[],
    public elements: GadgetGroupElement[],
    public options: string[]
  ){}
}

export class MapDisplayGadgget extends SimpleGadget{
  positionX: number;
  positionY: number;
  tagInformationType: number;
  tagPosition: string;
  tagDisplay: string;
  tagTextSize: string;
  tagBackground: boolean;
}

export const GadgetTypes = {
  SENSOR:1,
  BUTTON:2,
  WINDOW:3,
  LIGHT:4,
  BLIND:5,
  HEATING:6,
  MOTION_SENSOR:7,
  TEMPERATURE_SENSOR:8,
  CONSUMPTION_METER:9,
  SOCKET:10,
  NAS:11,
  CAMERA:12,
  PUSH_BUTTON:13,
  DOOR:14,
  RESET:15,
  POWER_SUPPLY:16,
  LIGHT_SENSOR:17,
  SAFE:18,
  MANUAL_PUSH_BUTTON:19,
  AUCA_EXTINGUISHER:20,
  AIR_CONDITIONER:21,
  IRRIGATION:22,
  HEATING_CIRCUIT:23,
  TEMPERATURE:24,
  UNIVERSAL_SWITCH:25,
  TURN_ON_ALARM:26,
  GAS_DETECTOR_PERCENT:27,
  GAS_DETECTOR_PPM:28,
  GAS_GROUP:29,
  GAS_CENTRAL_ZONE:30,
  FIRE_CENTRAL_ZONE:31,
  FIRE_DETECTOR_1:32,
  FIRE_DETECTOR_2:33,
  FIRE_DETECTOR_3:34,
  FIRE_DETECTOR_4:35,
  FIRE:36,
  LEAK_DETECTOR:37,
  GENERAL_ALARM:38,
  PHOTOCELL:39,
  PLAYER:40,
  INTERCOM:41,
  BOX:42,
  EMERGENCY_SIGNAL:43,
  MAINTENANCE:44,
  CUSTOMIZABLE:45,
  VARIATOR:46,
  ADJUSTABLE_BLIND:47,
  STATUS:48,
  LABEL:49,
  DIMMER:50,
  ETHERNET:51,
  LOCK: 52,
  VALVE:53,
  PUMP:54
};
